module.exports = __webpack_public_path__ + "img/spinner.997ef6b8.svg";